window.ONE = {};
window.ONE.lockReload = false;
var imagesList = $("#one-dom-container img");
for (var tempIndex = 0; tempIndex < imagesList.length; tempIndex++) {
  var tempImage = imagesList.eq(tempIndex);
  if (!tempImage.attr("src")) {
    tempImage.attr(
      "src",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    );
  }
}

var isPc = window.innerWidth >= 650;
var isWap = window.innerWidth < 650;

// 判断屏幕尺寸调整到跨端，整个网页进行重载
var oldWindow = {
  width: window.innerWidth, // 上一次重载的尺寸
  timeOut: null, // 节流
};
$(window).resize(function () {
  if (oldWindow.timeOut) return;
  oldWindow.timeOut = setTimeout(function () {
    ScrollTrigger.refresh();
    var newWindowWidth = window.innerWidth;
    if (
      (oldWindow.width >= 650 && newWindowWidth < 650) ||
      (oldWindow.width < 650 && newWindowWidth >= 650)
    ) {
      if (window.ONE.lockReload) {
        return;
      }
      window.location.reload && window.location.reload();
    }
    oldWindow.width = newWindowWidth;
    oldWindow.timeOut = null;
  }, 300);
});
window.ONE.onePin = function (selecter, px) {
  $(selecter).wrap("<div class='one-section-pin' style='height:calc(100vh + " + px + "px)'></div>");
}
// 移动端横屏问题
var refreshTimer = null;
window.addEventListener("orientationchange", () => {
  // 或者监听设备方向的变化
  refreshTimer = clearTimeout(refreshTimer);
  setTimeout(ScrollTrigger.refresh, 200);
});

window.ONE.keyAnimate = function (dom, startnum, picnum, fps) {
  var path = $(dom).attr("data-path");
  var type = $(dom).attr("data-type");
  $(dom).html(
    '<img style="width: 100%;height: 100%;" src="' +
      IMAGE_HOST +
      path +
      1 +
      type +
      '">'
  );
  return new Promise(function (resolve, reject) {
    let count = 0;
    let imgArr = [];
    for (let i = 0; i < picnum; i++) {
      imgArr[i] = new Image();
      imgArr[i].onload = function () {
        imgArr[i].onload = null;
        count++;
        if (count == picnum) {
          $(dom).find("img").remove();
          resolve(
            new CanvasKeyFrames(document.querySelector(dom), "array", imgArr, {
              fps: fps || 24, //动画速度
              width: 430,
              height: 764,
            })
          );
        }
      };
      imgArr[i].onerror = function () {};
      imgArr[i].src = IMAGE_HOST + path + (startnum + i) + type;
    }
  });
};
var mediaInit = function () {
  //处理优先加载
  var medias = $("#one-dom-container .data-one-firstload");
  for (var i = 0; i < medias.length; i++) {
    var src = medias[i].getAttribute("data-one-firstload-src");
    if (!src) {
      continue;
    }
    medias[i].setAttribute("src", IMAGE_HOST + src);
  }
  // 处理引用地址
  var imagesList = $("#one-dom-container img");
  for (var i = 0; i < imagesList.length; i++) {
    var src = imagesList[i].getAttribute("data-one-src");
    if (!src) {
      continue;
    }
    imagesList[i].setAttribute("src", IMAGE_HOST + src);
  }
  var sourceList = $("#one-dom-container picture source");
  for (var i = 0; i < sourceList.length; i++) {
    var src = sourceList[i].getAttribute("data-one-srcset");
    if (!src) {
      continue;
    }
    sourceList[i].setAttribute("srcset", IMAGE_HOST + src);
  }
  var videoList = $("#one-dom-container video");
  for (var i = 0; i < videoList.length; i++) {
    var src = videoList[i].getAttribute("data-one-src");
    if (!src) {
      continue;
    }
    videoList[i].setAttribute("src", IMAGE_HOST + src);
  }

  //注册图片懒加载
  // new LazyLoad({
  //   elements_selector: "#one-dom-container img",
  //   data_src: "one-src",
  //   data_srcset: "one-srcset",
  //   threshold: "3000",
  //   callback_enter: function (element) {},
  // });
  // new LazyLoad({
  //   elements_selector: "#one-dom-container video:not(.data-one-firstload)",
  //   data_src: "one-src",
  //   data_srcset: "one-srcset",
  //   threshold: "3000",
  //   callback_enter: function (element) {
  //     setTimeout(function () {
  //       // if (element.readyState != 4) {
  //       // 	console.log(element)
  //       // 	var src = element.src;
  //       // 	element.src = "";
  //       // 	element.insertAdjacentHTML('afterend', '<picture><source srcset="' + src.replace(".mp4", ".png.avif") + '" type="image/avif" /><source srcset="' + src.replace(".mp4", ".png.webp") + '" type="image/webp" /><img class="' + element.className + '" src="' + src.replace(".mp4", ".png") + '" /></picture>');
  //       // 	element.remove();
  //       // }
  //     }, 4000);
  //   },
  // });
};

var pcComponentsInit = function () {
  // 如果需要自制导航条,下滑隐藏,上滑显示
  var oTop1 = $(window).scrollTop();
  var scrollLock = false;
  $(window).scroll(function () {
    if (scrollLock) {
      return;
    }
    scrollLock = true;
    setTimeout(function () {
      scrollLock = false;
    }, 100);
    var oTop2 = $(window).scrollTop();
    if (oTop2 > oTop1) {
      $(".one-nav-tab").css("top", -60);
    } else {
      $(".one-nav-tab").css("top", 0);
    }
    oTop1 = $(window).scrollTop();
  });
  $(document).mousemove(function (e) {
    if (e.clientY <= 56) {
      $(".one-nav-tab").css("top", 0);
    }
  });

  // 样张拖动组件
  window.ONE.initDrag = function (isResizing, selectStr) {
    isResizing = false;
    $(selectStr + " .one-drag-controlBtn").mousedown(function (e) {
      isResizing = true;
    });
    $(selectStr + " .one-drag-controlBtn").mouseup(function (e) {
      isResizing = false;
    });

    var dragLimitWidth = $(selectStr).width() - 3;
    $(document).mousemove(function (e) {
      if (isResizing) {
        var newleft = e.clientX - $(selectStr).offset().left;
        newleft = newleft > dragLimitWidth ? dragLimitWidth : newleft;
        newleft = newleft < 0 ? 0 : newleft;
        var newWidth = dragLimitWidth - newleft;
        $(selectStr + " .one-drag-img2").width(newWidth);
        $(selectStr + " .one-drag-controlBtn").css("left", newleft);
      }
    });
  };

  //弹出框组件
  window.ONE.initPopup = function (selectBtnStr, selectStr) {
    $(selectStr).addClass("one-popup");
    $(selectStr).prepend(
      '<div class="one-popup-closeBtn-div"><svg class="one-popup-closeBtn" xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><path d="M15 29C22.1797 29 28 23.1797 28 16C28 8.82029 22.1797 3 15 3C7.82029 3 2 8.82029 2 16C2 23.1797 7.82029 29 15 29Z" fill="#0060EF"/><path d="M19.7178 12.2285L15.9463 15.998L19.7197 19.7715L18.7773 20.7148L15.0039 16.9414L11.2314 20.7139L10.2891 19.7715L14.0605 15.998L10.291 12.2285L11.2344 11.2861L15.0039 15.0557L18.7744 11.2852L19.7178 12.2285Z" fill="white"/></svg></div>'
    );
    $(selectStr).html(
      '<div class="one-popup-content">' + $(selectStr).html() + "</div>"
    );
    $(selectBtnStr).click(function () {
      var imagesList = $(selectStr + " img");
      for (var i = 0; i < imagesList.length; i++) {
        var src = imagesList[i].getAttribute("data-one-src");
        if (!src) {
          continue;
        }
        imagesList[i].setAttribute("src", src);
      }
      var sourceList = $(selectStr + " source");
      for (var i = 0; i < sourceList.length; i++) {
        var src = sourceList[i].getAttribute("data-one-srcset");
        if (!src) {
          continue;
        }
        sourceList[i].setAttribute("srcset", src);
      }
      var videosList = $(selectStr + " video");
      for (var i = 0; i < videosList.length; i++) {
        var src = videosList[i].getAttribute("data-one-src");
        if (!src) {
          continue;
        }
        videosList[i].setAttribute("src", src);
      }

      var contentheight = $(selectStr + " .one-popup-content").outerHeight();
      var contentColMargin = (window.innerHeight - contentheight) / 2;
      if (contentColMargin > 100) {
        $(selectStr + " .one-popup-content").css(
          "margin-top",
          contentColMargin
        );
        $(selectStr + " .one-popup-content").css("margin-bottom", 0);
      }
      $("html").css("overflow", "hidden");
      if (contentColMargin > 100) {
        //解决抖动问题
        $(selectStr).css("overflow", "hidden");
      }
      $(selectStr).scrollTop(0);
      $(selectStr + " .one-popup-content").css("top", "100vh");
      $(selectStr).css("visibility", "visible");
      $(selectStr + " .one-popup-content").animate(
        { top: 0 },
        500,
        function () {
          if (contentColMargin > 100) {
            //解决抖动问题
            $(selectStr).css("overflow", "auto");
          }
        }
      );
    });
    $(selectStr + " .one-popup-closeBtn").click(function () {
      $(selectStr).animate({ opacity: "0" }, 500, function () {
        $(selectStr).css("visibility", "hidden");
        $(selectStr).css("opacity", "1");
      });
      $("html").css("overflow", "auto");
    });
  };
};

var wapComponentsInit = function () {
  //弹出框组件
  window.ONE.initPopup = function (selectBtnStr, selectStr) {
    $(selectStr).addClass("one-popup");
    $(selectStr).prepend(
      '<div class="one-popup-closeBtn-div"><svg class="one-popup-closeBtn" xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><path d="M15 29C22.1797 29 28 23.1797 28 16C28 8.82029 22.1797 3 15 3C7.82029 3 2 8.82029 2 16C2 23.1797 7.82029 29 15 29Z" fill="#0060EF"/><path d="M19.7178 12.2285L15.9463 15.998L19.7197 19.7715L18.7773 20.7148L15.0039 16.9414L11.2314 20.7139L10.2891 19.7715L14.0605 15.998L10.291 12.2285L11.2344 11.2861L15.0039 15.0557L18.7744 11.2852L19.7178 12.2285Z" fill="white"/></svg></div>'
    );
    $(selectStr).html(
      '<div class="one-popup-content">' + $(selectStr).html() + "</div>"
    );
    $(selectBtnStr).click(function () {
      var imagesList = $(selectStr + " img");
      for (var i = 0; i < imagesList.length; i++) {
        var src = imagesList[i].getAttribute("data-one-src");
        if (!src) {
          continue;
        }
        imagesList[i].setAttribute("src", src);
      }
      var sourceList = $(selectStr + " source");
      for (var i = 0; i < sourceList.length; i++) {
        var src = sourceList[i].getAttribute("data-one-srcset");
        if (!src) {
          continue;
        }
        sourceList[i].setAttribute("srcset", src);
      }

      var contentheight = $(selectStr + " .one-popup-content").outerHeight();
      var contentColMargin = (window.innerHeight - contentheight) / 2;
      if (contentColMargin > 50) {
        $(selectStr + " .one-popup-content").css(
          "margin-top",
          contentColMargin
        );
        $(selectStr + " .one-popup-content").css("margin-bottom", 0);
      }
      $("html").css("overflow", "hidden");
      $(selectStr).scrollTop(0);
      $(selectStr + " .one-popup-content").css("top", "100vh");
      $(selectStr).css("visibility", "visible");
      $(selectStr + " .one-popup-content").animate({ top: 0 }, 500);
    });
    $(selectStr + " .one-popup-closeBtn").click(function () {
      $(selectStr).animate({ opacity: "0" }, 500, function () {
        $(selectStr).css("visibility", "hidden");
        $(selectStr).css("opacity", "1");
      });
      $("html").css("overflow", "auto");
    });
  };
};

$(document).ready(function () {
  if (
    (isPc &&
      window.navigator.userAgent.indexOf("Trident") > -1 &&
      window.navigator.userAgent.indexOf("rv:11.0") > -1) ||
    window.navigator.userAgent.indexOf("MSIE") > -1
  ) {
    // IE浏览器提示不支持
    // $(".one-dom-container").remove();
    // $(".loadingWt .one-loading-text").addClass("one-pc-flexCol");
    return;
  } else {
    $(".loadingWt").remove();
  }

  // 移除额外元素
  if (isPc) {
    $(".one-wapOnly").remove();
    $(".one-pcHide").remove();
  } else {
    $(".one-pcOnly").remove();
    $(".one-wapHide").remove();
  }

  //对原始Swiper方法附加操作,因为Swiper没有提供根据dom获取swiper对象的方法
  window.SourceSwiper = Swiper.bind(null);
  Swiper = function (swiperContainer, parameters) {
    // if (!parameters.autoplay) {
    // 	parameters.autoplay = {
    // 		delay: 3000, // 设置轮播的延迟时间
    // 		disableOnInteraction: true,
    // 	};
    // }
    if (parameters.spaceBetween == undefined) {
      parameters.spaceBetween = 20; // 设置轮播间距
    }
    parameters.noSwiping = true;
    // $(swiperContainer).find("p").addClass("swiper-no-swiping");
    var tempSwiper = new window.SourceSwiper(swiperContainer, parameters);
    tempSwiper.autoplay.pause();
    $(swiperContainer).addClass("my-one-swiper");
    $(swiperContainer).data("swiper", tempSwiper);
    return tempSwiper;
  };

  // 处理媒体
  mediaInit();
  // 处理公共组件
  if (isPc) {
    pcComponentsInit();
  } else {
    wapComponentsInit();
  }

  // 注册动画组件
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });

  if (isPc) {
    try {
      pcGSAPAnimateInit();
    } catch {}
  } else {
    try {
      wapGSAPAnimateInit();
    } catch {}
  }

  // 在初始化完动画之后,去掉定屏动画块与块之间的缝隙露底
  var allSections = $(".one-section");
  for (var i = 0; i < allSections.length; i++) {
    var parentDom = allSections.eq(i).parent();
    if (parentDom.hasClass("pin-spacer")) {
      parentDom.css(
        "background-color",
        allSections.eq(i).css("background-color")
      );
    }
  }

  //非绝对定位元素的上浮出现动画
  const textShowObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const element = entry.target;
          $(element).animate({ top: 0, opacity: 1 }, 500);
          observer.unobserve(element); // 停止观察该元素
        }
      });
    },
    { threshold: 0.1 } // 这里的 threshold 表示目标元素与视窗的交叉比例达到 10% 时就触发回调函数
  );
  // 找到所有需要触发动画效果的元素
  const textElements = document.querySelectorAll(".showA");
  // 将元素添加到 IntersectionObserver 中进行观察
  for (var i = 0; i < textElements.length; i++) {
    textShowObserver.observe(textElements[i]);
  }

  //切换按钮的出现动画
  const switchBtn1ShowObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        const element = entry.target;
        if (entry.isIntersecting) {
          $(element).addClass("active");
        } else {
          $(element).removeClass("active");
        }
      });
    },
    { threshold: 0.1 }
  );
  const switchBtn1Elements = document.querySelectorAll(".one-switchBtnList");
  for (var i = 0; i < switchBtn1Elements.length; i++) {
    switchBtn1ShowObserver.observe(switchBtn1Elements[i]);
  }

  // swiper在视窗中轮播,移出视窗停止轮播
  const swiperShowObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (
            !$(entry.target).hasClass("clickStop") &&
            $(entry.target).data("swiper").autoplay.running == false
          ) {
            $(entry.target).data("swiper").autoplay.start();
          }
        } else {
          $(entry.target).data("swiper").autoplay.stop();
        }
      });
    },
    { threshold: 0.1 }
  );
  const swiperElements = document.querySelectorAll(".my-one-swiper");
  for (var i = 0; i < swiperElements.length; i++) {
    swiperShowObserver.observe(swiperElements[i]);
  }
});
